// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelectHoursInputSkuFragment = {
  __typename?: 'Sku';
  id: string;
  name: string;
  tier: Types.SkuTier;
  period: Types.SubscriptionInterval;
  price: number;
  numberOfSessions: number;
  unitPrice: number;
  timeInMinutes: number;
  family: Types.SkuFamily;
};

export type SelectHoursInputSkusQueryVariables = Types.Exact<{
  tier: Types.SkuTier;
  period?: Types.InputMaybe<Types.SubscriptionInterval>;
  family?: Types.InputMaybe<Types.SkuFamily>;
}>;

export type SelectHoursInputSkusQuery = {
  __typename?: 'Query';
  skus: {
    __typename?: 'SkuBatchResponse';
    results: Array<{
      __typename?: 'Sku';
      id: string;
      name: string;
      tier: Types.SkuTier;
      period: Types.SubscriptionInterval;
      price: number;
      numberOfSessions: number;
      unitPrice: number;
      timeInMinutes: number;
      family: Types.SkuFamily;
    }>;
  };
};

export const SelectHoursInputSkuFragmentDoc = gql`
  fragment SelectHoursInput_Sku on Sku {
    id
    name
    tier
    period
    price
    numberOfSessions
    unitPrice
    timeInMinutes
    family
  }
`;
export const SelectHoursInputSkusDocument = gql`
  query SelectHoursInput_Skus(
    $tier: SkuTier!
    $period: SubscriptionInterval
    $family: SkuFamily
  ) {
    skus(tier: $tier, period: $period, count: 8, family: $family) {
      results {
        ...SelectHoursInput_Sku
      }
    }
  }
  ${SelectHoursInputSkuFragmentDoc}
`;

/**
 * __useSelectHoursInputSkusQuery__
 *
 * To run a query within a React component, call `useSelectHoursInputSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectHoursInputSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectHoursInputSkusQuery({
 *   variables: {
 *      tier: // value for 'tier'
 *      period: // value for 'period'
 *      family: // value for 'family'
 *   },
 * });
 */
export function useSelectHoursInputSkusQuery(
  baseOptions: Apollo.QueryHookOptions<
    SelectHoursInputSkusQuery,
    SelectHoursInputSkusQueryVariables
  > &
    (
      | { variables: SelectHoursInputSkusQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SelectHoursInputSkusQuery,
    SelectHoursInputSkusQueryVariables
  >(SelectHoursInputSkusDocument, options);
}
export function useSelectHoursInputSkusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectHoursInputSkusQuery,
    SelectHoursInputSkusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectHoursInputSkusQuery,
    SelectHoursInputSkusQueryVariables
  >(SelectHoursInputSkusDocument, options);
}
export function useSelectHoursInputSkusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectHoursInputSkusQuery,
        SelectHoursInputSkusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SelectHoursInputSkusQuery,
    SelectHoursInputSkusQueryVariables
  >(SelectHoursInputSkusDocument, options);
}
export type SelectHoursInputSkusQueryHookResult = ReturnType<
  typeof useSelectHoursInputSkusQuery
>;
export type SelectHoursInputSkusLazyQueryHookResult = ReturnType<
  typeof useSelectHoursInputSkusLazyQuery
>;
export type SelectHoursInputSkusSuspenseQueryHookResult = ReturnType<
  typeof useSelectHoursInputSkusSuspenseQuery
>;
export type SelectHoursInputSkusQueryResult = Apollo.QueryResult<
  SelectHoursInputSkusQuery,
  SelectHoursInputSkusQueryVariables
>;
